(() => {
  const root = document.documentElement;
  const guard = document.getElementById('dheart-market-guard');
  if (!guard) return;

  const strings = JSON.parse(document.getElementById('dheart-market-strings').textContent);
  const allowed = new Set(guard.dataset.allowedCountries.split(' '));
  const supported = new Set(JSON.parse(document.getElementById('dheart-market-countries').textContent));
  const rentals = new Set(guard.dataset.rentalIds.split(','));
  const ecgs = new Set(guard.dataset.ecgIds.split(','));
  const form = document.getElementById('dheart-market-form');
  const shopifyCountry = root.dataset.dheartShopifyCountry;
  const shopifyLanguage = form.elements.language_code.value;
  const languages = new Set(JSON.parse(document.getElementById('dheart-market-languages').textContent));
  const readLanguage = () => {
    try { return localStorage.getItem('dheart_language_choice') || ''; }
    catch { return ''; }
  };
  let defaultLanguage = '';
  try { defaultLanguage = sessionStorage.getItem('dheart_default_language') || ''; }
  catch {}
  const pathLanguage = [...languages].sort((a, b) => b.length - a.length).find(code =>
    location.pathname === '/' + code || location.pathname.startsWith('/' + code + '/') || location.pathname.startsWith('/' + code + '-')) || '';
  const linkedLanguage = defaultLanguage === shopifyCountry + ':' + shopifyLanguage ? '' : pathLanguage;
  const preferredLanguage = code => {
    const chosen = readLanguage() || linkedLanguage;
    return languages.has(chosen) ? chosen : code === 'IT' ? 'it' : 'en';
  };
  const rememberDefault = (code, language) => {
    if (readLanguage() || linkedLanguage) return;
    try { sessionStorage.setItem('dheart_default_language', code + ':' + language); }
    catch {}
  };
  const readChoice = () => {
    try { return localStorage.getItem('dheart_country_choice') || ''; }
    catch { return ''; }
  };
  const saveChoice = code => {
    try { localStorage.setItem('dheart_country_choice', code); }
    catch {}
  };
  const selected = readChoice();
  let country = '';
  let mode = 'pending';

  const decorate = () => {
    document.querySelectorAll('[data-dheart-product-id]').forEach(product => {
      const id = product.dataset.dheartProductId;
      const restrictedRental = rentals.has(id) && country !== 'IT';
      product.toggleAttribute('data-dheart-rental-restricted', restrictedRental);
      const placement = product.querySelector('.dheart-klarna klarna-placement');
      const variant = product.querySelector('[data-current-variant]');
      if (placement && variant && mode === 'allowed' && !restrictedRental) {
        try {
          const { price } = JSON.parse(variant.textContent);
          if (Number.isInteger(price) && price >= 0 && placement.dataset.purchaseAmount !== String(price)) {
            placement.dataset.purchaseAmount = price;
            window.KOSMApp?.updatePurchaseAmount(price);
            window.KlarnaOnsiteService?.push({ eventName: 'refresh-placements' });
          }
        } catch {}
      }
      product.querySelectorAll('.dheart-information-price, .dheart-product-contact, .dheart-rental-note').forEach(node => node.remove());
      const anchor = product.querySelector('.product-block-price, [data-variant-fragment="price"], .price, h1, h2, h3');
      if (!anchor) return;
      if (rentals.has(id)) {
        const note = document.createElement('p');
        note.className = 'dheart-rental-note';
        note.textContent = strings.rental;
        anchor.after(note);
      }
      if (mode === 'distributor' && ecgs.has(id)) {
        const price = document.createElement('p');
        price.className = 'dheart-information-price';
        price.textContent = country === 'IN' ? guard.dataset.priceIndia : guard.dataset.priceUk;
        anchor.after(price);
      }
      if ((mode === 'blocked' || mode === 'distributor' || restrictedRental) && product.hasAttribute('data-product-root')) {
        const link = document.createElement('a');
        link.className = 'dheart-product-contact';
        link.href = guard.dataset.contactUrl;
        link.textContent = strings.contact;
        anchor.after(link);
      }
    });
    document.querySelectorAll('.jdgm-cards-carousel a[href*="/products/"], .jdgm-review-widget .jm-product-variant-card a[href*="/products/"]').forEach(link => {
      const path = link.getAttribute('href');
      link.setAttribute('href', ecgPath(path));
    });
    if (mode !== 'allowed') {
      document.querySelectorAll('.jdgm-review-widget .jm-product-variant-card [role="button"]').forEach(button => {
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('tabindex', '-1');
      });
    }
    root.dataset.dheartRentalPage = String(country !== 'IT' && !!document.querySelector('[data-product-root][data-dheart-rental-restricted]'));
    root.dataset.dheartCartRental = String(country !== 'IT' && !!document.querySelector('[data-dheart-cart-product-id="7874416378080"], [data-dheart-cart-product-id="7874343403744"], [data-dheart-cart-product-id="7874372763872"]'));
  };

  const apply = code => {
    country = code;
    mode = ['IN', 'GB'].includes(code) ? 'distributor' : allowed.has(code) && code === shopifyCountry ? 'allowed' : 'blocked';
    root.dataset.dheartMarketAccess = mode;
    root.dataset.dheartDetectedCountry = code;
    document.querySelectorAll('.dheart-destination__select').forEach(select => {
      select.value = supported.has(code) ? code : '';
      select.dispatchEvent(new Event('change'));
    });
    decorate();
  };

  const ecgPath = path => {
    const handles = [
      ['dispositivo-ecg-professionale', 'dispositivo-ecg-d-heart-professionale-540-euro', 'dispositivo-ecg-d-heart-professionale-copia'],
      ['telecardiologia-2-0-dispositivo-ecg-per-farmacisti', 'telecardiologia-2-0-dispositivo-ecg-per-farmacisti-540', 'telecardiologia-2-0-dispositivo-ecg-per-farmacisti-1']
    ];
    return path.replace(/(\/products\/)([^/?#]+)/, (match, prefix, handle) => {
      const variants = handles.find(items => items.includes(handle));
      return variants ? prefix + variants[0] : match;
    });
  };
  const syncCountry = code => {
    const targetPath = ecgPath(form.elements.return_to.value);
    const language = preferredLanguage(code);
    if ((code === shopifyCountry && language === shopifyLanguage && targetPath === form.elements.return_to.value) || !supported.has(code)) {
      apply(code);
      return;
    }
    const attempt = shopifyCountry + ':' + code + ':' + language;
    try {
      if (sessionStorage.getItem('dheart_localization_attempt') === attempt) {
        apply('');
        return;
      }
      sessionStorage.setItem('dheart_localization_attempt', attempt);
    } catch {}
    form.elements.country_code.value = code;
    form.elements.language_code.value = language;
    rememberDefault(code, language);
    form.elements.return_to.value = targetPath;
    try { form.submit(); }
    catch { apply(''); }
  };

  document.addEventListener('submit', event => {
    if (event.target.matches('.dheart-language-dropdown__options')) {
      const language = event.submitter?.value;
      if (languages.has(language)) {
        try {
          localStorage.setItem('dheart_language_choice', language);
          sessionStorage.removeItem('dheart_default_language');
        } catch {}
      }
      return;
    }
    if (!event.target.matches('.dheart-destination__form')) return;
    const code = event.target.elements.country_code.value;
    event.target.elements.return_to.value = ecgPath(event.target.elements.return_to.value);
    const language = preferredLanguage(code);
    event.target.elements.language_code.value = language;
    rememberDefault(code, language);
    saveChoice(code);
    try { sessionStorage.removeItem('dheart_localization_attempt'); }
    catch {}
    if (code === shopifyCountry && language === shopifyLanguage) {
      event.preventDefault();
      apply(code);
    }
  });

  document.addEventListener('click', event => {
    document.querySelectorAll('.dheart-language-dropdown[open]').forEach(dropdown => {
      if (!dropdown.contains(event.target)) dropdown.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.dheart-language-dropdown[open]').forEach(dropdown => {
      dropdown.open = false;
      dropdown.querySelector('summary').focus();
    });
  });

  document.querySelectorAll('.dheart-destination__field').forEach(field => {
    const select = field.querySelector('select');
    const picker = field.querySelector('details');
    const trigger = picker.querySelector('summary');
    const value = picker.querySelector('.dheart-destination__value');
    const search = picker.querySelector('input');
    const items = [...picker.querySelectorAll('li')];
    const empty = picker.querySelector('.dheart-destination__empty');
    const submit = field.closest('form').querySelector('[type="submit"]');
    const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    const update = () => {
      value.textContent = select.selectedOptions[0]?.textContent || strings.choose;
      submit.disabled = !select.value;
      items.forEach(item => item.querySelector('button').setAttribute('aria-pressed', String(item.querySelector('button').dataset.country === select.value)));
    };
    const filter = () => {
      const query = normalize(search.value);
      items.forEach(item => { item.hidden = !normalize(item.textContent).includes(query); });
      empty.hidden = items.some(item => !item.hidden);
    };
    select.addEventListener('change', update);
    search.addEventListener('input', filter);
    picker.addEventListener('toggle', () => {
      if (!picker.open) return;
      search.value = '';
      filter();
      picker.querySelector('.dheart-destination__panel').scrollIntoView({ block: 'nearest' });
      search.focus({ preventScroll: true });
    });
    picker.addEventListener('click', event => {
      const button = event.target.closest('[data-country]');
      if (!button) return;
      select.value = button.dataset.country;
      select.dispatchEvent(new Event('change'));
      picker.open = false;
      trigger.focus();
    });
    picker.addEventListener('keydown', event => {
      if (event.key === 'Enter' && event.target === search) {
        event.preventDefault();
        const matches = items.filter(item => !item.hidden);
        if (matches.length === 1) matches[0].querySelector('button').click();
        return;
      }
      if (event.key === 'Escape') {
        picker.open = false;
        trigger.focus();
      }
      if (!picker.open || !['ArrowDown', 'ArrowUp'].includes(event.key)) return;
      const buttons = items.filter(item => !item.hidden).map(item => item.querySelector('button'));
      if (!buttons.length) return;
      event.preventDefault();
      const index = buttons.indexOf(document.activeElement);
      if (index < 0) {
        buttons[event.key === 'ArrowDown' ? 0 : buttons.length - 1].focus();
        return;
      }
      buttons[(index + (event.key === 'ArrowDown' ? 1 : -1) + buttons.length) % buttons.length].focus();
    });
    document.addEventListener('click', event => {
      if (!picker.contains(event.target)) picker.open = false;
    });
    select.required = false;
    select.hidden = true;
    picker.hidden = false;
    update();
  });

  if (supported.has(selected)) {
    syncCountry(selected);
  } else {
    const url = (window.Shopify?.routes?.root || '/') + 'browsing_context_suggestions.json?country[enabled]=true';
    fetch(url, { signal: AbortSignal.timeout(4000) })
      .then(response => response.ok ? response.json() : null)
      .then(data => {
        const detected = data?.detected_values?.country?.handle?.toUpperCase();
        if (detected && /^[A-Z]{2}$/.test(detected)) syncCountry(detected);
        else apply('');
      })
      .catch(() => apply(''));
  }

  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      observer.disconnect();
      decorate();
      observer.observe(document.body, { childList: true, subtree: true });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();


